function getSiblings(elm) {
    var a = []; //保存所有兄弟节点
    var p = elm.parentNode.children; //获取父级的所有子节点
    for (var i = 0; i < p.length; i++) {
      //循环
      if (p[i].nodeType == 1 && p[i] != elm) {
        //如果该节点是元素节点与不是这个节点本身
        a.push(p[i]); // 添加到兄弟节点里
      }
    }
    return a;
}

function lazyLoad(images) {
    // const images = document.querySelectorAll("[data-src]");
    const config = {
      rootMargin: "0px",
      threshold: 0
    };
    let observer = new IntersectionObserver((entries, self) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          // 加载图像
          preloadImage(entry.target);
          // 解除观察
          self.unobserve(entry.target);
        }
      });
    }, config);
    images.forEach(image => {
      observer.observe(image);
    });
  }

function preloadImage(img) {
    const src = img.dataset.src;
    if (!src) {
      return;
    }
    img.src = src;
}

export {getSiblings ,lazyLoad , preloadImage}